// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "device_push_token".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "device_push_token" table (1:1 with a DB row, on the wire). */
export const devicePushTokenAtomSchema = z.object({
    id: z.string(),
    userId: z.string(),
    token: z.string(),
    platform: z.string(),
    tokenType: z.string(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=devicePushToken.js.map